import React from 'react';
import {
  Box,
  Container,
  Typography,
  Grid,
  Button,
} from '@mui/material';
import {
  Phone,
  Email,
  LocationOn,
  Schedule,
  WhatsApp,
  Instagram,
} from '@mui/icons-material';
import { motion } from 'framer-motion';

const Contact: React.FC = () => {
  return (
    <Box sx={{ pt: { xs: '80px', sm: '90px' }, pb: { xs: 6, md: 10 }, backgroundColor: 'background.default' }}>
      <Container maxWidth="lg">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: true }}
        >
          <Typography
            variant="h2"
            sx={{
              textAlign: 'center',
              mb: 2,
              color: '#8B7355',
              fontWeight: 'bold',
              fontSize: { xs: '2rem', sm: '2.5rem', md: '3rem' },
            }}
          >
            Contact Us
          </Typography>
          
          <Typography
            variant="h6"
            sx={{
              textAlign: 'center',
              mb: { xs: 4, md: 6 },
              color: 'text.secondary',
              maxWidth: 600,
              mx: 'auto',
            }}
          >
            Get in touch with us for premium furniture solutions.
          </Typography>
        </motion.div>

        <Grid container spacing={4} sx={{ mb: 6 }}>
          <Grid item xs={12} sm={6} md={3}>
            <motion.div
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: 0 }}
              viewport={{ once: true }}
            >
              <Box
                component="a"
                href="tel:+916309561983"
                sx={{
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  justifyContent: 'center',
                  height: 220,
                  p: 3,
                  textAlign: 'center',
                  backgroundColor: 'white',
                  borderRadius: 2,
                  boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
                  textDecoration: 'none',
                  transition: 'all 0.3s ease',
                  '&:hover': {
                    transform: 'translateY(-5px)',
                    boxShadow: '0 8px 20px rgba(139,115,85,0.15)',
                  },
                }}
              >
                <Phone sx={{ fontSize: 40, color: '#8B7355', mb: 1 }} />
                <Typography variant="h6" sx={{ fontWeight: 'bold', color: '#8B7355', mb: 1, fontSize: '1.1rem' }}>
                  Phone
                </Typography>
                <Typography variant="body2" sx={{ color: 'text.primary', fontWeight: 500, fontSize: '0.95rem' }}>
                  +91 6309561983
                </Typography>
              </Box>
            </motion.div>
          </Grid>

          <Grid item xs={12} sm={6} md={3}>
            <motion.div
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: 0.1 }}
              viewport={{ once: true }}
            >
              <Box
                component="a"
                href="mailto:Ahmed83shareef@gmail.com"
                sx={{
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  justifyContent: 'center',
                  height: 220,
                  p: 3,
                  textAlign: 'center',
                  backgroundColor: 'white',
                  borderRadius: 2,
                  boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
                  textDecoration: 'none',
                  transition: 'all 0.3s ease',
                  '&:hover': {
                    transform: 'translateY(-5px)',
                    boxShadow: '0 8px 20px rgba(139,115,85,0.15)',
                  },
                }}
              >
                <Email sx={{ fontSize: 40, color: '#8B7355', mb: 1 }} />
                <Typography variant="h6" sx={{ fontWeight: 'bold', color: '#8B7355', mb: 1, fontSize: '1.1rem' }}>
                  Email
                </Typography>
                <Typography variant="body2" sx={{ color: 'text.primary', fontWeight: 500, fontSize: '0.95rem' }}>
                  Ahmed83shareef@gmail.com
                </Typography>
              </Box>
            </motion.div>
          </Grid>

          <Grid item xs={12} sm={6} md={3}>
            <motion.div
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: 0.2 }}
              viewport={{ once: true }}
            >
              <Box
                component="a"
                href="https://maps.app.goo.gl/S1bGpbdiLoPUiHKTA"
                target="_blank"
                rel="noopener noreferrer"
                sx={{
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  justifyContent: 'center',
                  height: 220,
                  p: 3,
                  textAlign: 'center',
                  backgroundColor: 'white',
                  borderRadius: 2,
                  boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
                  textDecoration: 'none',
                  transition: 'all 0.3s ease',
                  '&:hover': {
                    transform: 'translateY(-5px)',
                    boxShadow: '0 8px 20px rgba(139,115,85,0.15)',
                  },
                }}
              >
                <LocationOn sx={{ fontSize: 40, color: '#8B7355', mb: 1 }} />
                <Typography variant="h6" sx={{ fontWeight: 'bold', color: '#8B7355', mb: 1, fontSize: '1.1rem' }}>
                  Location
                </Typography>
                <Typography variant="body2" sx={{ color: 'text.primary', fontWeight: 500, fontSize: '0.95rem' }}>
                  Plot No 228, Manikonda
                </Typography>
              </Box>
            </motion.div>
          </Grid>

          <Grid item xs={12} sm={6} md={3}>
            <motion.div
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: 0.3 }}
              viewport={{ once: true }}
            >
              <Box
                sx={{
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  justifyContent: 'center',
                  height: 220,
                  p: 3,
                  textAlign: 'center',
                  backgroundColor: 'white',
                  borderRadius: 2,
                  boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
                }}
              >
                <Schedule sx={{ fontSize: 40, color: '#8B7355', mb: 1 }} />
                <Typography variant="h6" sx={{ fontWeight: 'bold', color: '#8B7355', mb: 1, fontSize: '1.1rem' }}>
                  Hours
                </Typography>
                <Typography variant="body2" sx={{ color: 'text.primary', fontWeight: 500, fontSize: '0.95rem' }}>
                  Mon-Sat: 9AM-7PM
                </Typography>
              </Box>
            </motion.div>
          </Grid>
        </Grid>

        <Box sx={{ textAlign: 'center' }}>
          <Typography
            variant="h4"
            sx={{ mb: 4, color: '#8B7355', fontWeight: 'bold' }}
          >
            Connect With Us
          </Typography>
          
          <Box sx={{ display: 'flex', gap: 2, justifyContent: 'center', flexWrap: 'wrap' }}>
            <Button
              variant="contained"
              size="large"
              startIcon={<WhatsApp />}
              href="https://wa.me/916309561983"
              target="_blank"
              sx={{
                backgroundColor: '#25D366',
                color: 'white',
                px: 4,
                py: 1.5,
                '&:hover': {
                  backgroundColor: '#128C7E',
                },
              }}
            >
              WhatsApp
            </Button>
            
            <Button
              variant="outlined"
              size="large"
              startIcon={<Instagram />}
              href="https://www.instagram.com/ahmed.shareef1983"
              target="_blank"
              sx={{
                borderColor: '#E4405F',
                color: '#E4405F',
                px: 4,
                py: 1.5,
                borderWidth: 2,
                '&:hover': {
                  backgroundColor: 'rgba(228, 64, 95, 0.1)',
                  borderWidth: 2,
                },
              }}
            >
              Instagram
            </Button>
          </Box>
        </Box>
      </Container>
    </Box>
  );
};

export default Contact;
